<template>
  <div id="app">
    <Loader />
    <router-view></router-view>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import Loader from './components/Loader/Loader.vue'

export default {
  name: 'app',
  components: {
    Loader
  },
  data:()=>({
    ip: ""
  }),
  methods: {
        toggleBodyClass(className) {
            if (className == 'dark') {
                document.body.classList.add('dark-theme');
            } else {
                document.body.classList.remove('dark-theme');
                
            }
        },
    },
  
mounted() {
  this.toggleBodyClass(themeConfig.theme)
},



}
</script>

<style>
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #555;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--primary);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--secondary);
}

@keyframes spinner {
  to { transform: rotate(360deg); }
}
.spin-icon{
  animation: spinner 1s linear infinite;
}

@font-face {
    font-family: "Nunito Sans";
    src: local("Nunito Sans"),
    url(./assets/fonts/Nunito/NunitoSans-VariableFont_YTLC,opsz,wdth,wght.ttf) format("truetype");
}

@font-face {
    font-family: "Noto Sans Arabic";
    src: local("NNoto Sans Arabic"),
    url(./assets/fonts/Noto/NotoSansArabic-Medium.ttf) format("truetype");
}

@font-face {
    font-family: "Montserrat";
    src: local("Montserrat"),
    url(./assets/fonts/Montserrat/Montserrat-Regular.ttf) format("truetype");
}

@font-face {
    font-family: "Roboto";
    src: local("Roboto"),
    url(./assets/fonts/Roboto/KFOmCnqEu92Fr1Mu4mxK.woff2) format("truetype");
    font-weight: 500;
}
@font-face {
    font-family: "Roboto";
    src: local("Roboto-Bold"),
    url(./assets/fonts/Roboto/KFOlCnqEu92Fr1MmEU9fBBc4.woff2) format("truetype");
    font-weight: 700;
}
@font-face {
    font-family: "Roboto";
    src: local("Roboto-light"),
    url(./assets/fonts/Roboto/KFOlCnqEu92Fr1MmSU5fBBc4.woff2) format("truetype");
    font-weight: 700;
}
</style>